import React, { useContext, useEffect, useRef, useState } from 'react';
import { useCart } from 'react-use-cart';
import { FaTimes, FaShoppingCart, FaMapMarkerAlt, FaPhone, FaUser, FaMoneyBillWave, FaTruck } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { config } from '../config';
import { OrderContext } from '../context/OrderContext';
import DistrictSelector from '../components/OrderPage/DistrictSelector';
import bdLocations from './locations';
import axios from 'axios';
import { FiClock, FiInfo, FiMapPin, FiTruck } from 'react-icons/fi';
import { initFacebookPixels, trackEventOnMultiplePixels } from '../pixel';
import { ProductContext } from '../context/ProductsContext';
import CheckoutDelivery from '../components/OrderPage/CheckoutDelivery';

const Checkout = () => {
    const { 
        isEmpty,
        items,
        cartTotal,
        emptyCart
    } = useCart();


  
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const token = localStorage.getItem('authToken') || null;
    const [dataSaved, setDataSaved] = useState(false);
    const [bonus, setBonus] = useState(false);
    const [divisions, setDivisions] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedDivisionName, setSelectedDivisionName] = useState('');
    const [selectedDistrictName, setSelectedDistrictName] = useState('');
    const randomNumber = `A2C${Math.floor(1000 + Math.random() * 90000)}`;
    const [checkoutTracked, setCheckoutTracked] = useState(false);

    const {
        apiUrl,
        imageUrl,
        name,
        address,
        phone,
        deliveryCharge,
        setDeliveryCharge,
        estimatedDays,
        setEstimatedDays,
        selectedDistrict,
        setSelectedDistrict,
        deliveryNote,
        setName,
        setAddress,
        setPhone,
        districts: districtData,
        
    } = useContext(OrderContext);


    const { pixel} = useContext(ProductContext);
    const [phoneError, setPhoneError] = useState("");

   // ফোন নাম্বার বাংলা থেকে ইংরেজি করার ফাংশন
    const handlePhoneChange = (e) => {
        const input = e.target.value;
        const bengaliToEnglish = {'০':'0', '১':'1', '২':'2', '৩':'3', '৪':'4', '৫':'5', '৬':'6', '৭':'7', '৮':'8', '৯':'9'};
        
        // বাংলা ডিজিট রিপ্লেস
        let convertedNumber = input.replace(/[০-৯]/g, match => bengaliToEnglish[match]);
        // ইংরেজি সংখ্যা ছাড়া সব মুছে ফেলা
        convertedNumber = convertedNumber.replace(/\D/g, '');
        
        setPhone(convertedNumber);

        if (convertedNumber.length > 0 && convertedNumber.length < 11) {
        setPhoneError("মোবাইল নম্বর অবশ্যই ১১ ডিজিটের হতে হবে");
        } else if (convertedNumber.length === 11 && !convertedNumber.startsWith("01")) {
        setPhoneError("সঠিক বাংলাদেশি মোবাইল নম্বর দিন (যেমন: 01...)");
        } else {
        setPhoneError(""); 
        }
    };

    const handleDistrictChange = (districtName) => {
        const districtInfo = districtData.find(d => d.district_name === districtName);
        if (districtInfo) {
            setDeliveryCharge(districtInfo.delivery_charge);
            setEstimatedDays(districtInfo.estimated_days);
        }
        setSelectedDistrictName(districtName);
        setSelectedDistrict(districtName);
    };


    // Helper function to get cookies
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    };


    // ফোন নাম্বার ফরম্যাট করার ফাংশন
    const formatPhoneForFacebook = (phone) => {
    if (!phone) return '';
    // শুধুমাত্র নাম্বার রাখুন
    const digitsOnly = phone.replace(/\D/g, '');
    // বাংলাদেশী নাম্বার হলে 880 যোগ করুন
    if (digitsOnly.length === 11 && !digitsOnly.startsWith('880')) {
        return `880${digitsOnly.substring(1)}`;
    }
    return digitsOnly;
    };

   

    
    // Purchase ইভেন্ট ট্র্যাক করার ফাংশন
    const trackingFired = useRef(false); // ডাবল ফায়ার রোধ করার জন্য

    useEffect(() => {
        // পিক্সেল এবং কার্টে আইটেম থাকলেই কেবল ইভেন্ট ফায়ার হবে
        if (pixel?.length > 0 && items.length > 0 && !trackingFired.current) {
            
            const eventId = randomNumber;
            const contentIds = items.map(item => String(item.product_id)); 
            
            const productsData = items.map(item => ({
                id: String(item.product_id),
                quantity: item.quantity,
                item_price: parseFloat(item.price) || 0
            }));
            
            const eventTime = Math.floor(Date.now() / 1000); 
            
            const eventData = {
                event_time: eventTime,
                value: parseFloat(cartTotal) || 0, // ⚠️ অবশ্যই Number হতে হবে
                currency: 'BDT',
                content_name: 'Checkout',
                content_ids: contentIds,
                contents: productsData,
                num_items: items.reduce((t, i) => t + i.quantity, 0),
                content_type: 'product',
                event_source_url: window.location.href,
                fbc: getCookie('_fbc'),
                fbp: getCookie('_fbp'),
            };

            // Client-side Pixel ইভেন্ট (event_id আলাদা অবজেক্টে পাঠানো হচ্ছে pixel.js এর নিয়ম অনুযায়ী)
            trackEventOnMultiplePixels(pixel, 'InitiateCheckout', {
                ...eventData,
                event_id: eventId
            });

            // Server-side CAPI (Purchase এর মতো InitiateCheckout ও CAPI তে পাঠানো ভালো)
            axios.post(`${apiUrl}/fb-track`, {
                event: 'InitiateCheckout',
                event_id: eventId,
                ...eventData
            }).catch(err => console.error("CAPI Tracking Error:", err));

            trackingFired.current = true; // একবার ফায়ার হলে আর হবে না
        }
    }, [pixel, items, cartTotal, apiUrl, randomNumber]);


    // Fetch bonus data
    useEffect(() => {
        const fetchBonuses = async () => {
            try {
                const response = await axios.get(`${apiUrl}/bonuscoins`);
                setBonus(response?.data?.[0]);
            } catch (err) {
                console.error("Error fetching bonuses:", err);
            }
        };
        fetchBonuses();
    }, [apiUrl]);

    // বিভাগ লোড
    useEffect(() => {
        const loadedDivisions = bdLocations.map(div => ({
            id: div.division.en,
            name: div.division.en,
            bn_name: div.division.bn
        }));
        setDivisions(loadedDivisions);
    }, []);

    // বিভাগ পরিবর্তন হলে সংশ্লিষ্ট জেলা লোড করুন
    useEffect(() => {
        if (selectedDivision) {
            const selectedDivData = bdLocations.find(
                div => div.division.en === selectedDivision
            );
            
            if (selectedDivData) {
                const loadedDistricts = selectedDivData.districts.map(dist => ({
                    id: dist.en,
                    name: dist.en,
                    bn_name: dist.bn
                }));
                
                setDistricts(loadedDistricts);
            }
        } else {
            setDistricts([]);
        }
    }, [selectedDivision]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const orderItems = items.map(item => {
            return {
            product_id: item.product_id,
            product_name: item.name,
            quantity: item.quantity,
            price: item.price,
            color: item.color || null,
            size: item.size || null,
            };
        });

        const orderData = {
            order_id: randomNumber,
            customer_name: name,
            phone_number: phone,
            customer_address: `Village/Road: ${address}, District: ${selectedDistrictName}, Division: ${selectedDivisionName}`,
            delivery_charge: deliveryCharge,
            total: Math.round(Number(cartTotal || 0) + Number(deliveryCharge || 0)),
            items: orderItems,
            payment_method: 'cod', // Add default payment method
            delivery_note: deliveryNote,
        };

        try {
            // 1. First submit the order
            const response = await axios.post(`${apiUrl}/cartstore`, orderData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
            });

            setDataSaved(true);
            emptyCart();
            window.location.href = `/thankyou/${randomNumber}`;
            
        } catch (error) {
            console.error('Order submission failed:', error);
            let errorMessage = 'অর্ডার সাবমিশন ব্যর্থ হয়েছে';

            if (error.response) {
            // Handle specific backend errors
            if (error.response.data.message === 'Insufficient coins') {
                errorMessage = `আপনার পর্যাপ্ত ${bonus.name} নেই`;
            } else if (error.response.data.errors) {
                // Show validation errors if any
                errorMessage = Object.values(error.response.data.errors).join('\n');
            }
            } else if (error.code === 'ECONNABORTED') {
            errorMessage = 'সার্ভারে রেসপন্স দিতে দেরি হচ্ছে। দয়া করে পরে আবার চেষ্টা করুন';
            }

            alert(errorMessage);
            setIsSubmitting(false);
        }
        };

    

    return (
        <div className="min-h-screen bg-gray-50">
            <Header />

            {/* Checkout Banner */}
            <div className="bg-gradient-to-r from-[#116d3c] to-[#0a2635] py-10 text-center text-white">
                <h1 className="text-4xl font-bold">Checkout</h1>
                <p className="mt-2 text-lg">
                    <Link to="/" className="hover:underline">Home</Link> / Checkout
                </p>
            </div>

            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 sm:px-0">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        {/* Customer Info Form */}
                        <div className="bg-white shadow overflow-hidden rounded-lg">
                            <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
                                <h3 className="text-lg leading-6 font-medium text-gray-900">
                                    Customer Information
                                </h3>
                            </div>
                            <div className="px-4 py-5 sm:p-6">
                                <form onSubmit={handleSubmit}>
                                    <div className="space-y-6">
                                      
                                        <div>
                                            <label className="block text-lg font-semibold mb-2 text-gray-700">
                                                মোবাইল নম্বর:
                                            </label>
                                            <input
                                                type="tel"
                                                value={phone}
                                                onChange={handlePhoneChange}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                placeholder="01XXXXXXXXX"
                                                maxLength="11"
                                                required
                                            />
                                            {phoneError && (
                                                <p className="text-red-500 text-sm mt-1">
                                                    {phoneError}
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-lg font-semibold mb-2 text-gray-700">
                                                আপনার নাম:
                                            </label>
                                            <input
                                                type="text"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                placeholder="পূর্ণ নাম লিখুন"
                                                required
                                            />
                                        </div>

                                        {/* বিভাগ সিলেক্ট */}
                                        <div className="mb-4">
                                            <label className="block text-lg font-semibold mb-2 text-gray-700">
                                                আপনার বিভাগ সিলেক্ট করুন:
                                            </label>
                                            <div className="relative">
                                                <select
                                                    value={selectedDivisionName}
                                                    onChange={(e) => {
                                                        const selectedOption = e.target.options[e.target.selectedIndex];
                                                        setSelectedDivision(selectedOption.id);
                                                        setSelectedDivisionName(selectedOption.value);
                                                        setSelectedDistrictName('');
                                                    }}
                                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition appearance-none"
                                                >
                                                    <option value="">বিভাগ সিলেক্ট করুন</option>
                                                    {divisions.map((division) => (
                                                        <option key={division.id} id={division.id} value={division.name}>
                                                            {division.bn_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>

                                      

                                        {/* জেলা সিলেক্ট */}
                                        <div className="mb-4">
                                            <label className="block text-lg font-semibold mb-2 text-gray-700">
                                                আপনার জেলা সিলেক্ট করুন:
                                            </label>
                                            <div className="relative">
                                                <select
                                                    value={selectedDistrictName}
                                                    onChange={(e) => setSelectedDistrictName(e.target.value)}
                                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition appearance-none"
                                                    disabled={!selectedDivision}
                                                >
                                                    <option value="">জেলা সিলেক্ট করুন</option>
                                                    {districts.map((district) => (
                                                        <option key={district.id} value={district.name}>
                                                            {district.bn_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-lg font-semibold mb-2 text-gray-700">
                                                আপনার গ্রাম/রোড:
                                            </label>
                                            <textarea
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                placeholder="বিস্তারিত ঠিকানা (থানা, গ্রাম/রোড)"
                                                rows="3"
                                                required
                                            />
                                        </div> 
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Order Summary */}
                        <div className="bg-white shadow overflow-hidden rounded-lg">
                            <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
                                <h3 className="text-lg leading-6 font-medium text-gray-900">
                                    Order Summary
                                </h3>
                            </div>
                            <div className="px-4 py-5 sm:p-6">
                                <div className="flow-root">
                                    <ul className="-my-4 divide-y divide-gray-200">
                                        {items.map((item) => (
                                            <li key={item.id} className="py-4 flex">
                                                <div className="flex-shrink-0 w-20 h-20 border border-gray-200 rounded-md overflow-hidden">
                                                    {
                                                        item.images && item.images.length > 0 ? (
                                                            <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                                                <img
                                                                    src={`${imageUrl}/${item.images[0]?.image}`}
                                                                    alt={item.name}
                                                                    className="h-full w-full object-cover object-center"
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200 flex items-center justify-center bg-gray-100 text-gray-500 text-sm">
                                                                <img
                                                                    src={`${imageUrl}/${item?.image}`}
                                                                    alt={item.name}
                                                                    className="h-full w-full object-cover object-center"
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                </div>

                                                <div className="ml-4 flex-1 flex flex-col">
                                                    <div>
                                                        <div className="flex justify-between text-base font-medium text-gray-900">
                                                            <h3>{item.name}</h3>
                                                            <p className="ml-4">৳{Math.round(item.price * item.quantity)}</p>
                                                        </div>
                                                        <p className="mt-1 text-sm text-gray-500">{item.color || ''} {item.size || ''}</p>
                                                    </div>
                                                    <div className="flex-1 flex items-end justify-between text-sm">
                                                        <p className="text-gray-500">পরিমাণ: {item.quantity}</p>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="mt-6 border-t border-gray-200 pt-6">

                                    {/* District Selector */}
                                    <CheckoutDelivery handleDistrictChange={handleDistrictChange} />

                                    <div className="flex justify-between text-base font-medium text-gray-900">
                                        <p>সাবটোটাল</p>
                                        <p>৳{Math.round(cartTotal)}</p>
                                    </div>

                                    {/* Delivery Charge */}
                                    <div className="flex justify-between items-center mb-2">
                                        <span className="text-gray-600">ডেলিভারি চার্জ ({selectedDistrict}):</span>
                                        <span className={`font-bold ${deliveryCharge === 0 ? 'text-green-600' : ''}`}>
                                        {deliveryCharge === 0 ? 'ফ্রি' : `৳${Math.round(deliveryCharge)}`}
                                        </span>
                                    </div>

                                      <div className="flex justify-between mt-4 text-lg font-bold text-gray-900">
                                        <p>সর্বমোট</p>
                                        <p>৳{Math.round(Number(cartTotal || 0) + Number(deliveryCharge || 0))}</p>
                                    </div>
                                </div>

                                <div className="mt-6 flex items-center text-sm text-gray-500">
                                    <FaTruck className="flex-shrink-0 mr-2 text-blue-500" />
                                    <p>
                                        {selectedDistrictName 
                                            ? `${selectedDistrictName}-এ আনুমানিক ডেলিভারি সময়: ${estimatedDays} কার্যদিবস`
                                            : 'ডেলিভারি সময় জেলা নির্বাচন করার পরে দেখানো হবে'
                                        }
                                    </p>
                                </div>

                                <div className="mt-6">
                                    <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        disabled={isSubmitting || !selectedDistrictName}
                                        className={`w-full flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-green-600 hover:bg-green-700 ${
                                            isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                                        } ${
                                            !selectedDistrictName ? 'opacity-50 cursor-not-allowed' : ''
                                        }`}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                প্রসেসিং...
                                            </>
                                        ) : (
                                            <>
                                                <FaShoppingCart className="mr-2" />
                                                অর্ডার নিশ্চিত করুন
                                            </>
                                        )}
                                    </button>
                                    {!selectedDistrictName && (
                                        <p className="text-sm text-red-500 mt-2 text-center">
                                            ডেলিভারি চার্জ দেখতে জেলা সিলেক্ট করুন
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Checkout;